import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import { Button, Tooltip } from '@main/complykit';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { useUserData } from '@nhost/react';

import { ImportCsvDataType, ImportDataFromCsvModal } from './import-data-from-csv';

export const EvidenceTab = ({ orgId }: { orgId: string }) => {
  const { data: organizationData } = useGetOrganizationQuery({ orgId });
  const organization = organizationData?.organizations_by_pk;

  const user = useUserData();
  const {
    isOpen: isNewEvidenceImportOpen,
    onOpen: onNewEvidenceOpenImport,
    onClose: onNewEvidenceCloseImport,
  } = useDisclosure();
  const {
    isOpen: isEvidenceControlImportOpen,
    onOpen: onEvidenceControlOpenImport,
    onClose: onEvidenceControlCloseImport,
  } = useDisclosure();

  return (
    <Stack gap={8}>
      <Box alignSelf="end">
        <Tooltip
          content='Enable "Controls module" for this organization'
          isDisabled={!!organization?.is_controls_module_enabled}
        >
          <Button
            isDisabled={!organization?.is_controls_module_enabled}
            onPress={onNewEvidenceOpenImport}
          >
            Import Evidence (CSV)
          </Button>
        </Tooltip>
      </Box>

      <Box alignSelf="end">
        <Tooltip
          content='Enable "Controls module" for this organization'
          isDisabled={!!organization?.is_controls_module_enabled}
        >
          <Button
            isDisabled={!organization?.is_controls_module_enabled}
            onPress={onEvidenceControlOpenImport}
          >
            Connect Control with Evidence (CSV)
          </Button>
        </Tooltip>
      </Box>

      <ImportDataFromCsvModal
        key="import-evidence-modal"
        importType={ImportCsvDataType.EVIDENCE}
        orgId={orgId}
        email={user?.email}
        isModalOpen={isNewEvidenceImportOpen}
        onModalClose={onNewEvidenceCloseImport}
      />

      <ImportDataFromCsvModal
        key="import-evidence-to-contol-modal"
        importType={ImportCsvDataType.EVIDENCE_TO_CONTROL}
        orgId={orgId}
        email={user?.email}
        isModalOpen={isEvidenceControlImportOpen}
        onModalClose={onEvidenceControlCloseImport}
      />
    </Stack>
  );
};
